import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormElementsModule } from '../../form-elements';

import { testUICompRouteModule } from './test-ui-route.module';
import { CommonComponentsModule } from 'src/app/common-components';
import { TestUIComponent } from './container/test-ui-component';
import * as testUIComps from './index';
import { AccordComponent } from '../../form-elements/accordion/accord.component'


@NgModule({
    declarations: [
        TestUIComponent,
        testUIComps.TestUIControlTypeOneComponent
    ],
    imports: [
        CommonModule,
        FormElementsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonComponentsModule,
        testUICompRouteModule

    ],
    exports: [ AccordComponent ]
})
export class TestUIModule { }
